// extracted by mini-css-extract-plugin
export var addToCartButton = "_on-b";
export var arrowButtonContainer = "_on-9";
export var arrowButtonIcon = "_on-a";
export var carouselArrowButton = "_on-6";
export var carouselElementContainer = "_on-1";
export var left = "_on-7";
export var productDisplayCarouselContainer = "_on-0";
export var productTileContainer = "_on-2";
export var productTileImage = "_on-4";
export var productTileImageContainer = "_on-3";
export var productTileTitle = "_on-5";
export var right = "_on-8";
export var sliderOverflow = "_on-c";